import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchFaq = createAsyncThunk(
    'faq/fetchFaq',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if (limit != null) {
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.faqListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch faq');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

export const fetchAllFaq = createAsyncThunk(
    'faq/fetchAllFaq',
    async (limit = null, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                apiUrls.faqListing,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const faqSlice = createSlice({
    name: 'category',
    initialState: {
        faq: [],
        limitLessFaq: [],
        limitLessLoader: false,
        data: [],
        loading: false,
        error: null
    },
    reducers: {
        clearFaqError: (state) => {
            state.error = null;
        },
        clearFaqs: (state) => {
            state.faq = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFaq.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFaq.fulfilled, (state, action) => {
                state.loading = false;
                state.faq = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchFaq.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAllFaq.pending, (state) => {
                state.limitLessLoader = true;
                state.error = null;
            })
            .addCase(fetchAllFaq.fulfilled, (state, action) => {
                state.limitLessLoader = false;
                state.limitLessFaq = action.payload;
            })
            .addCase(fetchAllFaq.rejected, (state, action) => {
                state.limitLessLoader = false;
                state.error = action.payload;
            });
    }
});

export const { clearFaqError, clearFaqs } = faqSlice.actions;
export default faqSlice.reducer;